import { FormattedMessage } from 'react-intl';

export const intlPrefix = 'registerWatch';

export const RegisterNewWatch = (
  <FormattedMessage
    defaultMessage='Register a new watch'
    id={`${intlPrefix}.registerNewWatch`}
  />
);

export const BuyWatch = (
  <FormattedMessage
    defaultMessage='Buy a watch'
    id={`${intlPrefix}.buyWatch`}
  />
);

export const WarrantyStatus = (
  <FormattedMessage
    defaultMessage='Warranty status'
    id={`${intlPrefix}.warrantyStatus`}
  />
);

export const SerialNumber = (
  <FormattedMessage
    defaultMessage='Serial Number:'
    id={`${intlPrefix}.serialNumber`}
  />
);
export const SeeMoreDetails = (
  <FormattedMessage
    defaultMessage='See more details'
    id={`${intlPrefix}.seeMoreDetails`}
  />
);

export const Description = (
  <FormattedMessage
    defaultMessage='Register your watch to access its digital documents, claim your
    blockchain-based digital passport and get access to many exclusive
    services.'
    id={`${intlPrefix}.description`}
  />
);
